import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { CustomerService } from 'src/app/services/customer.service';


@Component({
    selector: 'app-contractdetails',
    templateUrl: './contractdetails.component.html',
    styleUrls: ['./contractdetails.component.scss']
})

export class ContractDetailComponent implements OnInit {

    @Input() public cell: any;
    isFormSubmitted = false;
    vendorServiceList = [];
    service:any;
    product:any;
    origin:any;
    destination:any;
    contractVendors = [];
    formatedcontractVendors: any;
    centralizedContract: any;
    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private ngxLoaderService: NgxUiLoaderService,
        private _fb: FormBuilder,
        private customerService : CustomerService

    ) { }

    async ngOnInit() {

        this.getVendorRecoDetails();
    }
   async getVendorRecoDetails() {
        try {
            // console.log('cell',this.cell)
            this.customerService.getContractDetailById(this.cell).subscribe(async res => {
                if (res && res.success) {
                    // console.log("this modal",res.data );
                    const data = res.data;
                    this.vendorServiceList = data[0].additionaldetails[0].vendor;
                    this.product =  data[0].additionaldetails[0].product;
                    const service  = data[0].additionaldetails[0].service;
                    const flattenedServices = service.map(item => item.service).flat();
                    this.service = flattenedServices
                    const origin = data[0].additionaldetails[0].origin;
                    const formattedOrigin = origin.map(location => [location.country, location.state, location.city].filter(Boolean).join(' | '));
                    this.origin = formattedOrigin 
                    // console.log('origin',this.origin);

                    const destination= data[0].additionaldetails[0].destination;
                    const formattedDestination = destination.map(location => [location.country, location.state, location.city].filter(Boolean).join(' | '));
                    this.destination = formattedDestination 
                    
                    this.formatedcontractVendors = data[0].additionaldetails[0]?.contractvendors
                    ?.map(id => this.contractVendors.find(v => v.id === id)?.name)
                    ?.filter(name => name) // Remove undefined values
                    ?.join(', '); // Join names with comma separator   

                    const centralizedLocation = origin.find(location => location.centralizedcontract);
                    this.centralizedContract = centralizedLocation && 
                        [centralizedLocation.country, centralizedLocation.state, centralizedLocation.city]
                            .filter(Boolean)
                            .join(' | ')
                    // const origincountry: any = this.countryList.filter((item: any) => item.code == res.data[0]?.origincountrycode);
                    // const destinationcountry: any = this.countryList.filter((item: any) => item.code == res.data[0]?.destinationcountrycode);
                    // this.modelZoneForm.get('ddlProduct').setValue(res.data[0]?.productcode);
                    // this.modelZoneForm.get('ddlVendor').setValue(res.data[0]?.vendorcode);
                    // this.modelZoneForm.get('ddlZone').setValue(res.data[0]?.zonecode);
                    // this.modelZoneForm.get('ddlService').setValue(res.data[0]?.service);

                    // this.modelZoneForm.get('ddlOriginCountry').setValue(res.data[0]?.origincountrycode);
                    // this.modelZoneForm.get('ddlDestinationCountry').setValue(res.data[0]?.destinationcountrycode);
                    // await lastValueFrom(from(this.bindStatesByCountry(origincountry?.[0]?.isocode, 'origin')));

                    // originstate = this.originStateList?.filter((item: any) => item.code == res.data[0]?.originstatecode);
                    // await lastValueFrom(from(this.bindCitiesByState(originstate?.[0]?.isocode, 'origin')));

                    // this.modelZoneForm.get('ddlOriginState').setValue(res.data[0]?.originstatecode);
                    // this.modelZoneForm.get('ddlOriginCity').setValue(res.data[0]?.origincitycode);

                    // await lastValueFrom(from(this.bindStatesByCountry(destinationcountry?.[0]?.isocode)));
                    // destinationstate = this.destinationStateList?.filter((item: any) => item.code == res.data[0]?.destinationstatecode);
                    // await lastValueFrom(from(this.bindCitiesByState(destinationstate?.[0]?.isocode)));


                    // this.modelZoneForm.get('ddlDestinationState').setValue(res.data[0]?.destinationstatecode);
                    // this.modelZoneForm.get('ddlDestinationCity').setValue(res.data[0]?.destinationcitycode);

                    // this.modelZoneForm.get('txtOriginFromPincode').setValue(res.data[0]?.originpincodefrom);
                    // this.modelZoneForm.get('txtOriginToPincode').setValue(res.data[0]?.originpincodeto);
                    // this.modelZoneForm.get('txtDestinationFromPincode').setValue(res.data[0]?.destinationpincodefrom);
                    // this.modelZoneForm.get('txtDestinationToPincode').setValue(res.data[0]?.destinationpincodeto);
                    // this.modelZoneForm.get('txtFromDate').setValue(res.data[0]?.fromdate);
                    // this.modelZoneForm.get('txtToDate').setValue(res.data[0]?.todate);
                }
            })

        } catch (err: any) {
            this.ngxLoaderService.stop();
        }
    }
    reset(){

        this.activeModal.close('Cross click');
    }

}